import { sortOptions, multiSelectOptions } from '../filters';
import * as types from './types';

const InitialState = {
  sortedActive: false,
  checkedStatus: 'none',
  showDownloadReportModal: false,
  confirmDownloadReportModal: false,
  confirmDateFrom: '',
  confirmDateTo: '',
  sortOptionSelected: sortOptions[0],
  sortOptions,
  multiSelectOptions
};

const FilterTableReducer = (state = InitialState, action) => {
  switch (action.type) {
    case types.SHOW_REPORT_MODAL:
      state.showDownloadReportModal = action.payload;
      return { ...state };
    default:
      return { ...state };
  }
};

export { FilterTableReducer };
